import bluehost from "../build/web/bluehost/tokens.json";
import hostgator from "../build/web/hostgator/tokens.json";
import vodien from "../build/web/vodien/tokens.json";
import bigrock from "../build/web/bigrock/tokens.json";
import crazydomains from "../build/web/crazydomains/tokens.json";
import domain from "../build/web/domain/tokens.json";
import defaultTheme from "../build/web/default/tokens.json";
import freeparking from "../build/web/freeparking/tokens.json";
import networksolutions from "../build/web/networksolutions/tokens.json";
import register from "../build/web/register/tokens.json";
import reseller from "../build/web/reseller/tokens.json";
import web from "../build/web/web/tokens.json";
export function getTokensByBrand(brand) {
    const tokens = {
        bluehost,
        hostgator,
        vodien,
        bigrock,
        crazydomains,
        domain,
        default: defaultTheme,
        freeparking,
        networksolutions,
        register,
        reseller,
        web,
    };
    if (brand in tokens)
        return tokens[brand];
    return defaultTheme;
}
export default {
    hostgator,
    vodien,
    bluehost,
    bigrock,
    crazydomains,
    domain,
    default: defaultTheme,
    freeparking,
    networksolutions,
    register,
    reseller,
    web,
    getTokensByBrand,
};
